import React, { Component } from 'react'

export class Test extends Component {
  render() {
    return (
      <div>Test</div>
    )
  }
}

export default Test